import { render, staticRenderFns } from "./PreventionWrite.vue?vue&type=template&id=36d8c9c2&scoped=true&"
import script from "./PreventionWrite.vue?vue&type=script&lang=js&"
export * from "./PreventionWrite.vue?vue&type=script&lang=js&"
import style0 from "./PreventionWrite.vue?vue&type=style&index=0&id=36d8c9c2&scoped=true&lang=css&"
import style1 from "./PreventionWrite.vue?vue&type=style&index=1&id=36d8c9c2&lang=scss&scoped=true&"
import style2 from "./PreventionWrite.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d8c9c2",
  null
  
)

export default component.exports